// hooks/useHabilitationCaisse.js
// ============================================================================
// PEUT-IL TENIR UNE CAISSE ?
// ============================================================================
//
// Tout mouvement d'argent — frais d'inscription et de réinscription,
// mensualités, paiements, dépenses, salaires — s'inscrit dans la caisse du jour
// de celui qui l'enregistre. Depuis le 16 septembre 2026, c'est réservé aux
// rôles Comptable et Gestionnaire pédagogique, ou à une dérogation individuelle
// « Tenir une caisse » (COMPTABILITE_ET_PAIE.CAISSE.TENIR).
//
// Le serveur tranche (backend2/utils/caisseJournaliere.js) ; ce hook sert
// seulement à ne pas proposer une saisie qui serait refusée. La liste reçue
// n'inclut pas cette permission au titre d'ALL_MODULES : le passe-partout
// n'ouvre pas la caisse.
// ============================================================================

import { usePermissions } from './usePermissions';

export const PERMISSION_TENIR_CAISSE = 'COMPTABILITE_ET_PAIE.CAISSE.TENIR';

export const MESSAGE_CAISSE_RESERVEE =
  "L'enregistrement des frais et des paiements est réservé aux profils Comptable et "
  + "Gestionnaire pédagogique : vous n'êtes pas habilité à tenir une caisse. "
  + "Vous pouvez enregistrer l'élève sans frais — un comptable encaissera ensuite — "
  + "ou demander une dérogation « Tenir une caisse » à l'administration.";

export const useHabilitationCaisse = () => {
  const { detailedPermissions, loading } = usePermissions();

  const habilite = (detailedPermissions || []).some((p) =>
    (p.permission_key || p.key) === PERMISSION_TENIR_CAISSE
    || (p.module === 'COMPTABILITE_ET_PAIE' && p.sous_module === 'CAISSE' && p.action === 'TENIR')
  );

  return { habilite, chargement: Boolean(loading) };
};

export default useHabilitationCaisse;
